<ion-item lines="none" class="week-slider-item">

  <yu-icon
    slot="start"
    name="caret-left"
    color="dark"
    (click)="subtractDays(7)"
  ></yu-icon>

  <ion-label (click)="goToday()">

    @if (isToday) {
      {{ 'COMPONENTS.WEEK_SLIDER.THIS_WEEK' | translate }}

    } @else {
      {{ fromDate | date: 'dd' }} - {{ valueTo | date: 'dd' }}
      <span style="text-transform: capitalize">{{ valueTo | date: 'MMMM' }}</span>
    }

    @if (optionalData) {
      <span class="optional-data">{{ optionalData }}</span>
    }

  </ion-label>

  <yu-icon
    slot="end"
    name="caret-right"
    color="dark"
    (click)="addDays(7)"
  ></yu-icon>

</ion-item>
